import $ from 'jquery';
import Parallax from './Parallax';

const getRandom = (_min, _max) => {
  const min = Math.ceil(_min);
  const max = Math.floor(_max);
  return Math.floor(Math.random() * (max - min)) + min;
};

export default class Banner {
  constructor(element) {
    this.element = element;
    this.$element = $(element);
    this.preprocess();
    this.ready();
  }

  preprocess() {
    this.$element.find('.node').each((a, node) => {
      // Add more text below the title.
      $('.read-more-text', node).each((b, more) => {
        $('.node-header a', node).append(`<span class="more btn-primary btn-large">${$(more).text()}</span>`);
      });

      // Add parallax background image.
      const $fieldImages = $('.node-upper-image .field-image', node);
      const winner = getRandom(0, $fieldImages.length);
      const $activeImage = $fieldImages.eq(winner);
      $fieldImages.not($activeImage).remove();
      $activeImage.each((b, image) => {
        const src = $('img', image).attr('data-src');
        if (src && src.length) {
          $('a', image).css('background-image', `url(${src})`);
        }
        node.Parallax = new Parallax(image);
      });
    });
  }

  ready() {
    return this.$element.addClass('ready');
  }
}
